




























/* eslint-disable @typescript-eslint/camelcase */ 

    import {   guiaOnlineService } from '@/servicegerente';

	import $ from "jquery"  
 
    import { Component, Vue } from 'vue-property-decorator';
      
    @Component({
        components: { },
    })
    export default class IndexGuia extends Vue { 

        private  reloadDatatable = false ; 
        private  token = '' ; 

        private config = { 
            responsive: {
                details: { 
                    display: $.fn.dataTable.Responsive.display.modal( {
                        header: function ( row: any ) {  
                            return 'Descrição' ;
                        }, 
                    } ),

                    renderer: function ( api: any, rowIdx: any, columns: any ) {
                        const data = $.map( columns, function ( col, i ) {
                            return col.hidden ?
                                '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+ '<td class="escuro-modal-texto">'+col.data+'</td>'+
                                '</tr>' + '<tr><td><br><hr></td></tr>'+ '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+ '<td>'+col.data+'</td>'+ '</tr>' : '';
                        } ).join('');
                            
                        return data ?
                            $('<table/>').append( data ) :
                            false;
                    } 
                }
            },
            ativacao: {
                url: guiaOnlineService.getUrl(),
                item: 'guia_online',
            },
            exclusao: {
                url: guiaOnlineService.getUrl(),
                evento: 'guia_onlineRemovida',
                item: 'guia_online',
            },
            order: [  [2, "asc"] ],
            ajax: {
                url: guiaOnlineService.getUrl() + '/datatable',
            },
            columns: [
                { "class": "details-control text-success", "orderable": false, "data": null, "defaultContent": ""  },  
                { data: 'id', name: 'id',  class: 'text-center' },
                { data: 'nome',  name: 'nome'  }, 
                { data: 'descricao',  name: 'descricao',  class: 'none' },  
                { data: 'action',  name: 'action', orderable: false, searchable: false,  class: 'text-center' }, 
            ],

        };
 


         created() {
            const temp_token = localStorage.getItem('user');
            if(temp_token){
                this.token =  JSON.parse(temp_token)   ;
            }
              
        }



        public tableatualizada( ) {  
             
             
            $('[btn-editar]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id'); 
                window.open('#/guia_online/edit/' + id);  
            });
            $('[btn-visualizar]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id'); 
                this.$router.push('/guia_online/show/' + id);
            });
            
            // $('[btn-pdf]').click(  (btn) => {  
            //     const id =   $(btn.currentTarget).data('id'); 
            //     window.open( guiaOnlineService.getUrl() + '/' + id + '/pdf?token=' + this.token);
            // });

            $('[btn-desativar]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id');  
                window.alertConfimacao('Confirma a Desativação ','' , 
                     () => {  
                        window.alertProcessando(); 
                        guiaOnlineService.desativar(  id )
                        .then(response => {
                            window.alertProcessandoHide();  
                            this.reloadDatatable = !this.reloadDatatable; 
                            window.toastSucesso('desativação realizada com sucesso!!' ); 
                        })
                        .catch(error => { 
                            window.alertProcessandoHide();
                            window.toastErro('Não foi possivel desativar ' , error.data.message); 
                        });  
                    }
                ); 
            });
    
            $('[btn-ativar]').click(  (btn) => {   
                const id =   $(btn.currentTarget).data('id'); 
                window.alertConfimacao('Confirma a Ativação ','' , 
                     () => {  
                        window.alertProcessando(); 
                        guiaOnlineService.ativar(  id )
                        .then(response => {
                            window.alertProcessandoHide();  
                            this.reloadDatatable = !this.reloadDatatable; 
                            window.toastSucesso('ativação realizada com sucesso!!' ); 
                        })
                        .catch(error => { 
                            window.alertProcessandoHide();
                            window.toastErro('Não foi possivel ativar ' , error.data.message); 
                        });  
                    }
                ); 
            });
    
            $('[btn-excluir]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id');  
                window.alertConfimacao('Confirma a Exclusão ','' , 
                     () => {  
                        window.alertProcessando(); 
                        guiaOnlineService.excluir(  id )
                        .then(response => {
                            window.alertProcessandoHide();  
                            this.reloadDatatable = !this.reloadDatatable; 
                            window.toastSucesso('Exclusao realizada com sucesso!!' ); 
                        })
                        .catch(error => { 
                            window.alertProcessandoHide();
                            window.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }
                ); 
            });

        }
    }
 
